import { getSettingsValue } from './getSettingsValue';
export function getSettingsValues(values, params, options) {
    if (options === void 0) { options = {}; }
    var acc = {};
    Object.keys(params).forEach(function (paramKey) {
        var param = params[paramKey];
        acc[param.key] = getSettingsValue(values, param, options);
    });
    return acc;
}
//# sourceMappingURL=getSettingsValues.js.map